import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import ProfileTab from "../../../core/common/profiletab";
import Table from "../../../core/common/dataTable/index";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import useApi from "../../../core/customhook/useApi";
import Swal from "sweetalert2";

const NominationsGratutity = () => {
  const {
    data: onboardingstatus,
    loading: onboardingstatusLoading,
    error: onboardingstatusError,
  } = useApi("/api/onboarding/final-status", {
    method: "GET",
    autoCall: true,
  });

  const status = onboardingstatus?.data?.onb_status;
  const [editData, setEditData] = useState<any>({});
  const [getData, setGetData] = useState(1);
  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body;
  };
  const routes = all_routes;

  const columns1 = [
    {
      title: "S.No.",
      dataIndex: "sno",
      render: (text: number) => (
        <p className="fs-14 fw-medium d-flex align-items-center mb-0">{text}</p>
      ),
    },
    {
      title: "Name",
      dataIndex: "first_name",
    },
    {
      title: "Gender",
      dataIndex: "gender",
    },
    {
      title: "Relation",
      dataIndex: "relation",
    },
    {
      title: "Date Of Birth",
      dataIndex: "nominee_dob",
    },
    {
      title: "Percentage(%)",
      dataIndex: "percentange",
    },
    {
      title: "Address",
      dataIndex: "nominee_address",
    },
    {
      title: "Guardian Name",
      dataIndex: "guardian_name",
    },
    {
      title: "Guardian Relation",
      dataIndex: "guardian_relation",
    },
    {
      title: "Guardian Address",
      dataIndex: "guardian_address",
      render: (text: string) => <p className="mb-0">{text}</p>,
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_: any, record: any) => {
        const canEdit =
          status === "In Progress" ||
          status === "Rejected" ||
          status === "Re Open" ||
          status === "Not Started";

        return (
          <i
            className="ti ti-edit text-primary"
            style={{
              cursor: canEdit ? "pointer" : "not-allowed",
              opacity: canEdit ? 1 : 0.5,
            }}
            title={
              canEdit
                ? "Edit"
                : "Editing is disabled for this status"
            }
            onClick={() => {
              if (canEdit) {
                setEditData(record);
              }
            }}
            data-bs-toggle={canEdit ? "modal" : undefined}
            data-bs-target={canEdit ? "#editexampleModalLg" : undefined}
          />
        );
      },
    }

  ];

  const {
    data: nomineeData,
    loading: nomineeLoading,
    error: nomineeError,
  } = useApi("/api/onboarding/get-nomination", {
    method: "GET",
    autoCall: true,
  });

  const {
    data: nomineeViewData,
    loading: nomineeViewLoading,
    error: nomineeViewError,
  } = useApi("/api/onboarding/view-nomination", {
    method: "POST",
    payload: {
      nomination_type: "Gratuity",
    },
    autoCall: true,
    dependencies: [getData],
  });

  const addSNo = nomineeViewData?.data?.map((item: any, index: any) => {
    return {
      ...item,
      sno: index + 1,
    };
  });

  const [data, setData] = useState({
    nomination_type: "Gratuity",
    nominee_id: "",
    gender: "",
    relation: "",
    nominee_dob: "",
    percentange: "",
    nominee_address: "",
    guardian_name: "",
    guardian_relation: "",
    guardian_address: "",
  });

  const getInputData = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const getEditData = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setEditData({ ...editData, [name]: value });
  };

  const {
    data: familyData,
    loading,
    error,
    callApi: postNomineeData,
  } = useApi("/api/onboarding/add-nomination", {
    method: "POST",
    autoCall: false,
  });

  const postData = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const response = await postNomineeData(data);
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.message || "Data submitted successfully!",
          confirmButtonColor: "#3085d6",
        }).then(() => {
          document.getElementById("closeModalBtn")?.click();
        });
        setGetData(getData + 1);
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text:
          error?.response?.data?.message ||
          "Something went wrong while submitting the form.",
        confirmButtonColor: "#d33",
      });
    }
  };

  const {
    data: nomineeEditData,
    loading: nomineeEditLoading,
    error: nomineeEditError,
    callApi: editNomineeData,
  } = useApi("/api/onboarding/edit-nomination", {
    method: "POST",
    autoCall: false,
  });

  const handleEdit = async (e: any) => {
    e.preventDefault();
    try {
      const payload = {
        ...editData,
        nomination_id: editData.nomination_id,
      };
      const response = await editNomineeData(payload);
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.message || "Data submitted successfully!",
          confirmButtonColor: "#3085d6",
        }).then(() => {
          document.getElementById("editcloseModalBtn")?.click();
        });
        setGetData(getData + 1);
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text:
          error?.response?.data?.message ||
          "Something went wrong while submitting the form.",
        confirmButtonColor: "#d33",
      });
    }
  };
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Nominations</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Administration</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Nominations
                  </li>
                </ol>
              </nav>
            </div>
            <div className="head-icons ms-2">
              <CollapseHeader />
            </div>
          </div>

          <div className="row">
            <div className="col-xl-3 theiaStickySidebar">
              <div
                className="stickybar"
                style={{ position: "sticky", top: "50px" }}
              >
                <ProfileTab />
              </div>
            </div>
            <div className="col-xl-9">
              <div className="card">
                <div className="card-body d-flex justify-content-between">
                  <div className="">
                    <h4>PF/Gratuity/ESIC Nomination</h4>
                  </div>
                  {
                    status === "In Progress" || status === "Rejected" || status === "Re Open" || status === "Not Started" ? <button
                      className="btn btn-primary custom_button"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModalLg"
                    >
                      {" "}
                      <i className="ti ti-circle-plus me-2" />
                      Add New Nominee Gratuity
                    </button> : ""
                  }

                </div>
                <div className="card">
                  <Table
                    dataSource={addSNo || []}
                    columns={columns1}
                    Selection={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModalLg"
        tabIndex={-1}
        aria-labelledby="exampleModalLgLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLgLabel">
                Nomination Add
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closeModalBtn"
              />
            </div>
            <div className="modal-body">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={postData}>
                    <div className="border-bottom mb-3">
                      <div className="row">
                        <div className="col-md-12">
                          <h6 className="mb-3">Nomination (Gratuity)</h6>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Type<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter nomination type"
                                name="nomination_type"
                                onChange={getInputData}
                                value={data.nomination_type}
                                readOnly
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Nominee<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                name="nominee_id"
                                id=""
                                className="form-select"
                                onChange={getInputData}
                                required
                              >
                                <option value="">Select Nominee</option>
                                {nomineeData?.data.map(
                                  (item: any, index: any) => (
                                    <option value={item.ID}>
                                      {item.first_name} {item.last_name}
                                    </option>
                                  )
                                )}
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Gender
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                className="form-control"
                                name="gender"
                                required
                                defaultValue=""
                                onChange={getInputData}
                              >
                                <option value="" disabled>
                                  Select Gender
                                </option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Other">Other</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Relation with nominee
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                className="form-control"
                                name="relation"
                                required
                                defaultValue=""
                                onChange={getInputData}
                              >
                                <option value="" disabled>
                                  Select relation
                                </option>
                                <option value="father">Father</option>
                                <option value="mother">Mother</option>
                                <option value="spouse">Spouse</option>
                                <option value="brother">Brother</option>
                                <option value="sister">Sister</option>
                                <option value="other">Other</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Nominee DOB
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <div className="input-icon-end position-relative">
                                <DatePicker
                                  className="form-control datetimepicker"
                                  format="DD-MM-YYYY"
                                  getPopupContainer={getModalContainer}
                                  placeholder="DD-MM-YYYY"
                                  name="nominee_dob"
                                  value={
                                    data.nominee_dob
                                      ? dayjs(data.nominee_dob, "DD/MM/YYYY")
                                      : null
                                  }
                                  onChange={(date) =>
                                    setData((prev) => ({
                                      ...prev,
                                      nominee_dob: date
                                        ? date.format("DD/MM/YYYY")
                                        : "",
                                    }))
                                  }
                                  disabledDate={(current) =>
                                    current &&
                                    current.isAfter(dayjs().startOf("day"))
                                  }
                                  required
                                />
                                <span className="input-icon-addon">
                                  <i className="ti ti-calendar text-gray-7" />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Percentage (%)
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Enter percentage"
                                name="percentange"
                                onChange={getInputData}
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="row align-items-start mb-3">
                            <div className="col-xxl-2 col-md-3">
                              <label className="form-label mb-md-0">
                                Nominee Address<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-xxl-10 col-md-9">
                              <textarea
                                className="form-control"
                                placeholder="Enter nominee address"
                                name="nominee_address"
                                onChange={getInputData}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="border-bottom mb-3">
                      <div className="row">
                        <div className="col-md-12">
                          <p className="mb-3">
                            If the nominee is a minor - enter name, relationship
                            and address of the Legal Guardian
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Name
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter guardian name"
                                name="guardian_name"
                                onChange={getInputData}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Relation
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                className="form-control"
                                name="guardian_relation"
                                defaultValue=""
                                onChange={getInputData}
                              >
                                <option value="" disabled>
                                  Select relation
                                </option>
                                <option value="father">Father</option>
                                <option value="mother">Mother</option>
                                <option value="spouse">Spouse</option>
                                <option value="brother">Brother</option>
                                <option value="sister">Sister</option>
                                <option value="other">Other</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="row align-items-start mb-3">
                            <div className="col-xxl-2 col-md-3">
                              <label className="form-label mb-md-0">
                                Address
                              </label>
                            </div>
                            <div className="col-xxl-10 col-md-9">
                              <textarea
                                className="form-control"
                                placeholder="Enter guardian address"
                                name="guardian_address"
                                onChange={getInputData}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Buttons */}
                    <div className="d-flex align-items-center justify-content-end">
                      <button
                        type="button"
                        className="btn btn-outline-light border me-3"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary custom_button">
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="editexampleModalLg"
        tabIndex={-1}
        aria-labelledby="exampleModalLgLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLgLabel">
                Edit Nomination Details
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="editcloseModalBtn"
              />
            </div>
            <div className="modal-body">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleEdit}>
                    <div className="border-bottom mb-3">
                      <div className="row">
                        <div className="col-md-12">
                          <h6 className="mb-3">Nomination (Gratuity)</h6>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Type<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter nomination type"
                                name="nomination_type"
                                onChange={getEditData}
                                value={editData.nomination_type}
                                readOnly
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Nominee<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                name="nominee_id"
                                id=""
                                className="form-select"
                                onChange={getEditData}
                                value={editData.nominee_id}
                                required
                              >
                                <option value="">Select Nominee</option>
                                {nomineeData?.data.map(
                                  (item: any, index: any) => (
                                    <option value={item.ID}>
                                      {item.first_name} {item.last_name}
                                    </option>
                                  )
                                )}
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Gender
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                className="form-control"
                                name="gender"
                                required
                                onChange={getEditData}
                                value={editData.gender}
                              >
                                <option value="" disabled>
                                  Select Gender
                                </option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Other">Other</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Relation with nominee
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                className="form-control"
                                name="relation"
                                required
                                onChange={getEditData}
                                value={editData.relation}
                              >
                                <option value="" disabled>
                                  Select relation
                                </option>
                                <option value="father">Father</option>
                                <option value="mother">Mother</option>
                                <option value="spouse">Spouse</option>
                                <option value="brother">Brother</option>
                                <option value="sister">Sister</option>
                                <option value="other">Other</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Nominee DOB
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <div className="input-icon-end position-relative">
                                <DatePicker
                                  className="form-control datetimepicker"
                                  format="DD-MM-YYYY"
                                  getPopupContainer={getModalContainer}
                                  placeholder="DD-MM-YYYY"
                                  name="nominee_dob"
                                  value={
                                    editData.nominee_dob
                                      ? dayjs(
                                        editData.nominee_dob,
                                        "DD/MM/YYYY"
                                      )
                                      : null
                                  }
                                  onChange={(date) =>
                                    setEditData((prev: any) => ({
                                      ...prev,
                                      nominee_dob: date
                                        ? date.format("DD/MM/YYYY")
                                        : "",
                                    }))
                                  }
                                  disabledDate={(current) =>
                                    current &&
                                    current.isAfter(dayjs().startOf("day"))
                                  }
                                  required
                                />
                                <span className="input-icon-addon">
                                  <i className="ti ti-calendar text-gray-7" />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Percentage (%)
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Enter percentage"
                                name="percentange"
                                onChange={getEditData}
                                value={editData.percentange}
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="row align-items-start mb-3">
                            <div className="col-xxl-2 col-md-3">
                              <label className="form-label mb-md-0">
                                Nominee Address<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-xxl-10 col-md-9">
                              <textarea
                                className="form-control"
                                placeholder="Enter nominee address"
                                name="nominee_address"
                                onChange={getEditData}
                                value={editData.nominee_address}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="border-bottom mb-3">
                      <div className="row">
                        <div className="col-md-12">
                          <p className="mb-3">
                            If the nominee is a minor - enter name, relationship
                            and address of the Legal Guardian
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Name
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter guardian name"
                                name="guardian_name"
                                onChange={getEditData}
                                value={editData.guardian_name}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Relation
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                className="form-control"
                                name="guardian_relation"
                                onChange={getEditData}
                                value={editData.guardian_relation}
                              >
                                <option value="" disabled>
                                  Select relation
                                </option>
                                <option value="father">Father</option>
                                <option value="mother">Mother</option>
                                <option value="spouse">Spouse</option>
                                <option value="brother">Brother</option>
                                <option value="sister">Sister</option>
                                <option value="other">Other</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="row align-items-start mb-3">
                            <div className="col-xxl-2 col-md-3">
                              <label className="form-label mb-md-0">
                                Address
                              </label>
                            </div>
                            <div className="col-xxl-10 col-md-9">
                              <textarea
                                className="form-control"
                                placeholder="Enter guardian address"
                                name="guardian_address"
                                onChange={getEditData}
                                value={editData.guardian_address}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Buttons */}
                    <div className="d-flex align-items-center justify-content-end">
                      <button
                        type="button"
                        className="btn btn-outline-light border me-3"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NominationsGratutity;
